import CalendarViewHeadTile from './CalendarViewHeadTile.vue';

export default CalendarViewHeadTile;
